export const referenceStateEnum = Object.freeze({
    "NEW": 0,
    "CONTACT": 1,
    "CATALOGUE": 2,
    "APPOINTMENT": 3,
    "SOS": 4,
    "SOD": 5,
    "FINISH": 6,
    "WITHDRAWAL": 7
});